import styled from 'styled-components'
import { Header, Segment } from 'semantic-ui-react'

export const WelcomeHeader = styled(Header)`
  font-size: 28px !important;
  font-weight: 400 !important;
  color: #333 !important;
  margin-bottom: 16px !important;
`

export const InfoText = styled.p`
  font-size: 14px;
  color: #333;
  line-height: 1.6;
  margin-bottom: 8px !important;
`

export const SectionTitle = styled(Header)`
  font-size: 24px !important;
  font-weight: 400 !important;
  color: #333 !important;
  margin-top: 24px !important;
  margin-bottom: 16px !important;
`

export const SubSectionTitle = styled(Header)`
  font-size: 16px !important;
  font-weight: 600 !important;
  color: #333 !important;
  margin-bottom: 12px !important;
`

export const FormContainer = styled(Segment)`
  background-color: transparent !important;
  border: none !important;
  box-shadow: none !important;
  padding: 0 !important;
`

export const FieldsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 12px 24px;
  align-items: end;
`

export const FieldsGridAnimalGroup = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 12px 24px;
  align-items: end;
`

export const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const FieldLabel = styled.label`
  font-size: 12px;
  color: #666;
  display: flex;
  align-items: baseline;
  gap: 6px;

  .icon {
    margin: 0 !important;
    font-size: 17px !important;
  }
`

export const FieldValue = styled.div`
  background-color: #e8e8e8;
  padding: 8px 12px;
  font-size: 14px;
  color: #333;
  min-height: 36px;
  border-radius: 6px;
  display: flex;
  align-items: center;
`

export const ContactInfo = styled.div`
  background-color: #fff8e1;
  padding: 12px 16px;
  border-radius: 8px;
  margin-bottom: 20px;
  font-size: 14px;
  color: #333;
`

export const TermsBox = styled.div<{ $borderColor?: string }>`
  border: 1px solid ${props => props.$borderColor || '#ccc'};
  border-radius: 4px;
  padding: 16px;
  margin-top: 24px;
  margin-bottom: 16px;
  background-color: #fff;
`

export const TermsText = styled.p`
  font-size: 14px;
  color: #333;
  line-height: 1.6;
  margin: 0;
`

export const TermsLink = styled.span`
  color: ${props => props.theme?.firstColor || '#1976d2'};
  cursor: pointer;
  text-decoration: underline;

  &:hover {
    opacity: 0.8;
  }
`

export const CheckboxWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  cursor: pointer !important;
  margin-top: 12px;

  .ui.checkbox {
    margin-top: 2px;
  }
`

export const CheckboxLabel = styled.span`
  font-size: 14px;
  color: #333;
  line-height: 1.5;
`

export const StyledFileSection = styled.div<{ $primaryColor: string }>`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px dashed #dee2e6;
  max-width: 500px;

  .file-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    background: ${props => props.$primaryColor || '#a03'};
    border-radius: 8px;
    color: white;
    flex-shrink: 0;
  }

  .file-info {
    flex: 1;
    min-width: 0;

    .file-label {
      font-size: 0.75rem;
      color: #6c757d;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      margin-bottom: 0.25rem;
    }

    .file-name {
      font-weight: 500;
      color: #212529;
      cursor: pointer;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      &:hover {
        color: ${props => props.$primaryColor || '#a03'};
        text-decoration: underline;
      }
    }

    .file-placeholder {
      color: #adb5bd;
      font-style: italic;
    }
  }

  .file-actions {
    flex-shrink: 0;
  }
`
